package com.example.webcv.pages.resume.model

data class ResumeItem(
    val title: String,
    val period: String,
    val description: String
)